// @flow
import React from "react";
import classnames from "classnames";
import { Responsive, List } from "semantic-ui-react";

import Styles from "./TariffComparison.module.scss";

type Props = {
  label: string | Node,
  value: ?string,
  className?: string,
  labelBold?: boolean,
  primaryColor?: boolean,
};

const TariffRow = ({ label = "", value, className, labelBold = false, primaryColor = false }: Props) => {
  return (
    <List.Item
      className={classnames(className, { [Styles.tarrifRow]: !labelBold, "theme-color-primary": primaryColor })}
    >
      <Responsive maxWidth={Responsive.onlyComputer.minWidth - 1}>
        <List.Content>{labelBold ? <List.Header>{label}</List.Header> : label}</List.Content>
        <List.Content>
          <List.Description>{value}</List.Description>
        </List.Content>
      </Responsive>
      <Responsive minWidth={Responsive.onlyComputer.minWidth}>
        <List.Content floated="right">
          <List.Description>
            <span className={primaryColor ? "theme-color-primary" : ""}>{value}</span>
          </List.Description>
        </List.Content>
        <List.Content>{labelBold ? <List.Header>{label}</List.Header> : label}</List.Content>
      </Responsive>
    </List.Item>
  );
};

export default TariffRow;
